import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

function Button(props) {
    return (
    <div className="MainButton" onClick={props.onClick}>
        <div className='MainButtonText'><ChevronRightRoundedIcon sx={{color:'#000'}}/>{props.name}</div>
    </div>
    )
}
export default Button;